import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f169a356"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 무료 진단하기 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 무료 진단하기 ")

import { getImageUrl } from '@/utils/getImageUrl'
import Text from '@/components/common/TextComponent.vue'
import { COLOR_SET, FONT_WEIGHT } from '@/styles/variables'


export default /*#__PURE__*/_defineComponent({
  name: 'Main',
  setup(__props) {

const toRefund = () => {
  const prod = 'https://app.sole.overtax.co.kr/login/?target=medistream'
  const stag = 'https://sole-app.stag.overtax.co.kr/login/?target=medistream'
  const dev = 'http://local.stag.overtax.co.kr:8080/login/?target=medistream'

  const url = process.env.NODE_ENV === 'production' ? prod : process.env.NODE_ENV === 'staging' ? stag : dev 

  location.href = url
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "main",
      style: _normalizeStyle({ 'background-image': `url(${_unref(getImageUrl)('medistream/main.png')})` }),
      onClick: toRefund
    }, null, 4),
    _createElementVNode("div", {
      class: "item",
      style: _normalizeStyle({ 'background-image': `url(${_unref(getImageUrl)('medistream/1.png')})` })
    }, null, 4),
    _createElementVNode("div", {
      class: "item",
      style: _normalizeStyle({ 'background-image': `url(${_unref(getImageUrl)('medistream/2.png')})` })
    }, null, 4),
    _createElementVNode("div", {
      class: "item",
      style: _normalizeStyle({ 'background-image': `url(${_unref(getImageUrl)('medistream/3.png')})` })
    }, null, 4),
    _createElementVNode("div", {
      class: "item",
      style: _normalizeStyle({ 'background-image': `url(${_unref(getImageUrl)('medistream/4.png')})` })
    }, null, 4),
    _createElementVNode("div", {
      class: "button",
      onClick: toRefund
    }, [
      _createVNode(Text, {
        color: _unref(COLOR_SET).white,
        weight: _unref(FONT_WEIGHT).bold,
        size: "30px"
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["color", "weight"])
    ]),
    _createElementVNode("div", {
      class: "main-mobile",
      style: _normalizeStyle({ 'background-image': `url(${_unref(getImageUrl)('medistream/main_m.png')})` }),
      onClick: toRefund
    }, null, 4),
    _createElementVNode("div", {
      class: "button-mobile",
      onClick: toRefund
    }, [
      _createVNode(Text, {
        color: _unref(COLOR_SET).white,
        weight: _unref(FONT_WEIGHT).bold,
        size: "30px"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["color", "weight"])
    ]),
    _createElementVNode("div", {
      class: "item-mobile",
      style: _normalizeStyle({ 'background-image': `url(${_unref(getImageUrl)('medistream/1_m.png')})` })
    }, null, 4),
    _createElementVNode("div", {
      class: "item-mobile",
      style: _normalizeStyle({ 'background-image': `url(${_unref(getImageUrl)('medistream/2_m.png')})` })
    }, null, 4),
    _createElementVNode("div", {
      class: "item-mobile small",
      style: _normalizeStyle({ 'background-image': `url(${_unref(getImageUrl)('medistream/3_m.png')})` })
    }, null, 4),
    _createElementVNode("div", {
      class: "item-mobile last",
      style: _normalizeStyle({ 'background-image': `url(${_unref(getImageUrl)('medistream/4_m.png')})` })
    }, null, 4)
  ]))
}
}

})